import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { RtTooltip, IconButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-like-button',
  template: `
    <rt-icon-button
      [rtTooltip]="'app.reactions.tooltip_like' | translate"
      variant="plain"
      size="small"
      shape="square"
      iconName="thumb-up"
    >
    </rt-icon-button>
  `,
  imports: [IconButtonComponent, RtTooltip, TranslatePipe],
})
export class LikeButtonComponent {}
